export { default } from './PaymentProfileIcon';
